<template>
  <section id="banner">
    <div
      v-if="isReturningCustomer"
      class="inner atlas-banner"
    >
      <h1>New Loan Request</h1>
      <p>
        To process your new loan request, we need to verify the information you provided on your most recent
        application.
      </p>
    </div>
    <div
      v-else
      class="inner atlas-banner"
    >
      <h1>{{ bannerTitle }}</h1>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isReturningCustomer: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    getRouteName() {
      return this.$route.name;
    },
    bannerTitle() {
      switch (this.getRouteName) {
        case ("step-1"):
          return "Let’s Start with the Basics.";
        case ("step-2"):
          return "Now we just need some identification details.";
        case ("step-3"):
          return "Let’s dive a little deeper.";
        case ("step-4"):
          return "You’re almost finished.";
        default:
          return "Let’s Start with the Basics.";
      }
    },
  }
};
</script>
